import React, { useCallback } from 'react';
import { getIn } from 'formik';

import { TextField } from '../../../text-field';
import { NumberFormatCustom } from './number-format';
import { FieldElementPropTypes } from '../../propTypes';

const Numeric = ({
  field: { id, name, label, mode, format, value, onChange: customOnChange, ...props },
  ctx: { handleChange, touched, errors, classes, setFieldTouched, setFieldValue }
}) => {
  const onChange = useCallback(
    (e) => {
      handleChange(e);
      setFieldValue(id, e.target.value);
      setFieldTouched(id, !!value, false); // Avoid field touched by react-number-format onChange
      if (customOnChange) {
        customOnChange(e.target.value);
      }
    },
    [handleChange, setFieldTouched, id, value, customOnChange, setFieldValue]
  );

  const { inputProps, InputProps, noMarginRight, ...elemProps } = props || {};

  return (
    <TextField
      key={id}
      id={id}
      name={name || id}
      label={label}
      value={typeof value === 'number' ? value : undefined}
      onChange={onChange}
      error={getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={getIn(touched, name || id) && getIn(errors, name || id)}
      mode={mode}
      fullWidth
      classes={classes[id]}
      style={noMarginRight ? undefined : { marginRight: 8 }}
      {...elemProps}
      InputProps={{
        inputComponent: NumberFormatCustom,
        inputProps: {
          format,
          id
        },
        name: name || id,
        ...(inputProps || {}),
        ...(InputProps || {})
      }}
    />
  );
};

Numeric.propTypes = FieldElementPropTypes;

export default Numeric;
